import { useTranslation } from "../../../i18n/I18nContext";
import { LANDING_MAX, LANDING_PAD_X } from "./landingLayout";

export function LandingHowItWorks() {
  const { t } = useTranslation();
  const steps = [
    { num: "1", icon: "/icons/chatting.svg", title: t("howItWorks.step1Title"), desc: t("howItWorks.step1Desc") },
    { num: "2", icon: "/icons/facetime.webp", title: t("howItWorks.step2Title"), desc: t("howItWorks.step2Desc") },
    { num: "3", icon: "/icons/translate.webp", title: t("howItWorks.step3Title"), desc: t("howItWorks.step3Desc") },
  ];
  return (
    <section
      id="how-it-works"
      aria-labelledby="how-it-works-title"
      className="w-full py-12 sm:py-14 lg:py-[76px]"
    >
      <div className={`${LANDING_MAX} ${LANDING_PAD_X}`}>
        <div className="flex flex-col gap-4 text-center sm:gap-5 lg:gap-[25px]">
          <h2
            id="how-it-works-title"
            className="font-bold leading-[1.3] text-[28px] sm:text-[34px] lg:text-5xl xl:text-[48px]"
          >
            {t("howItWorks.title")}{" "}
            <span className="text-primary">{t("howItWorks.titleHighlight")}</span>
          </h2>
          <p className="text-base leading-relaxed sm:text-lg lg:text-[20px] lg:leading-[32.5px]">
            {t("howItWorks.subtitle")}
          </p>
        </div>
        <div className="mt-8 grid grid-cols-1 gap-0 sm:mt-10 lg:mt-[50px] lg:grid-cols-3">
          {steps.map((step, i) => (
            <div
              key={step.num}
              className={`px-5 py-8 sm:px-6 sm:py-8 lg:px-[38px] ${
                i === 0
                  ? "rounded-t-[20px] bg-[#EFF5FF] lg:rounded-l-[20px] lg:rounded-tr-none"
                  : i === 1
                    ? "bg-[#E0ECFF]"
                    : "rounded-b-[20px] bg-[#D6E1FC] lg:rounded-r-[20px] lg:rounded-bl-none"
              } `}
            >
              <div className="flex flex-row items-center justify-between gap-4">
                <img src={`/icons/step${step.num}.svg`} alt="" className="h-[104px] w-10 shrink-0" aria-hidden />
                <img src={step.icon} alt="" className="h-[120px] w-[120px] shrink-0 object-contain sm:h-[130px] sm:w-[130px]" aria-hidden />
              </div>
              <div className="mt-7 sm:mt-8 lg:mt-[35px]">
                <h3 className="mb-2.5 font-semibold text-[#253477] text-xl sm:text-2xl">{step.title}</h3>
                <p className="text-[16px] leading-[1.7] sm:text-[18px] sm:leading-[30.6px]">{step.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
